import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

const COLORS = ['#6366f1', '#8b5cf6', '#10b981', '#f59e0b', '#ef4444', '#3b82f6'];

const TrendChart = ({ title, data, lines, height = 280, loading }) => {
  if (loading) {
    return (
      <div className="bi-chart-card">
        {title && <h3 className="bi-chart-title">{title}</h3>}
        <div className="bi-chart-skeleton" style={{ height }} />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="bi-chart-card">
        {title && <h3 className="bi-chart-title">{title}</h3>}
        <div className="bi-chart-empty" style={{ height }}>No data available</div>
      </div>
    );
  }

  return (
    <div className="bi-chart-card">
      {title && <h3 className="bi-chart-title">{title}</h3>}
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--admin-gray-200)" />
          <XAxis dataKey="date" tick={{ fontSize: 11 }} stroke="var(--admin-gray-400)" />
          <YAxis tick={{ fontSize: 11 }} stroke="var(--admin-gray-400)" />
          <Tooltip
            contentStyle={{
              background: 'white',
              border: '1px solid var(--admin-gray-200)',
              borderRadius: '8px',
              fontSize: '12px',
            }}
          />
          {lines.length > 1 && <Legend />}
          {lines.map((line, i) => (
            <Line
              key={line.key}
              type="monotone"
              dataKey={line.key}
              name={line.label || line.key}
              stroke={line.color || COLORS[i % COLORS.length]}
              strokeWidth={2}
              dot={false}
              activeDot={{ r: 4 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrendChart;
